export default __webpack_public_path__ + "static/media/mdm.2737274f.png";